{
  "version": 1,
  "asset_id": "ca243faa-a917-4ec9-9a92-495b36aec38a",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/ca243faa-a917-4ec9-9a92-495b36aec38a/metal-roof-installation-citrus-county-fl-640.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/ca243faa-a917-4ec9-9a92-495b36aec38a/metal-roof-installation-citrus-county-fl-640.avif",
  "original_filename": "metal-roof-installation-citrus-county-fl-640.avif",
  "size": 31091,
  "content_type": "image/avif",
  "created_at": "2026-07-16T15:35:58Z"
}
